import React, { useEffect, useState } from "react";
import {
  FloatButton,
  Drawer,
  Select,
  DatePicker,
  Button,
  Skeleton,
  ConfigProvider,
  Space,
  Radio,
} from "antd";

const { RangePicker } = DatePicker;
import dayjs from "dayjs";
const MAX_DAYS = 90;
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useSelector } from "react-redux";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { formatDateTime, generatedISOFormatDateString } from "../../../../../../Utils/DateConverstion";
import { FilterOutlined } from "@ant-design/icons";
import Empty from "../../../../../CommonScreens/Empty";
import CustomDrawer from "../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../Elements/CustomSelect";
// import TreeSelectCustomWithSelectAll from "../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
import ReactECharts from "echarts-for-react";
import TreeSelectCustom from "../LiveTrends/LineChart/TreeSelectCustom";
import LineChart from "./LineChart";
import StackedColumnChart from "./StackedColumnChart";
import GroupedColumnChart from "./GroupedColumnChart";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver"
// Extend plugins
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);
import ExcelJS from "exceljs";
import minnotra_logo from "../../../../../../Assets/Images/logo2.png";
import SteamTreeSelectCustomWithSelectAll from "../LiveTrends/LineChart/TreeSelectCustomWithAllSelect";


const PlotInterval = () => { 
  const { loading, makeRequest } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState(1); 
  const [converterGroupId, setConverterGroupId] = useState(1);
    const [defaultLoad,setDefaultLoad]=  useState(true)
    
  const [report, setReport] = useState([]);
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [selectedValues, setSelectedValues] = useState(["KWT"]);
  const [fromDateObj, setFromDateObj] = useState(dayjs().subtract(1, "day").startOf("day").format("YYYY-MM-DD HH:mm:ss"));
  const [fromDateString, setFromDateString] = useState(dayjs().subtract(1, "day").startOf("day").format("YYYY-MM-DD HH:mm:ss"));
  const [toDateObj, setToDateObj] = useState(dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss"));
  const [toDateString, setToDateString] = useState(dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss"));
  const [skip, setSkip] = useState(true);
  const [activeTab, setActiveTab] = useState("1");
  const [open, setOpen] = useState(false);
  const [datesError, setDatesError] = useState(null);
  const [chartSkip, setChartSkip] = useState();
  const [chartInput, setChartInput] = useState();
  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [paraError, setParaError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();
  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] =useState([]);
  const [showCalendar, setShowCalendar] = useState(false);
  // const [value, setValue] = useState([null, null]);
  const [value, setValue] = useState([dayjs().subtract(1, "day").startOf("day"),dayjs().startOf("day")]);
  const [plotInterval, setPlotInterval] = useState(4);
  const [functionType, setFunctionType] = useState(1);
  const [plotIntervalError, setPlotIntervalError] = useState(""); 
  const [functionTypeError, setFunctionTypeError] = useState("");
  const [plotIntervalOptions,setPlotIntervaloptions]=useState([])
  const [functionOptions,setFunctionOptions]=useState([])
  const [functions,setFunctions]=useState([])
  const [excelFromDate,setExcelFromDate]=useState()
  const [excelToDate,setExcelToDate]=useState()

  const [steamRawData, setsteamRawData] = useState([]);
  const [parameter, setParameter] = useState([]);
  const defaultParameters = ["kWhImport", "KWT", "IAVG", "VLLAvg"];

  const mode = useSelector((state) => state.darkMode);
    const [excelImage, setExcelImage] = useState(null);
   const loggedIn = useSelector((state) => state.user);
  // console.log(loggedIn)
  useEffect(()=>{

    setExcelImage(loggedIn?.images?.excelImage?`data:image/png;base64,${loggedIn?.images?.excelImage}`:null);
  },[loggedIn])

  const { isdarkMode } = mode;
  const color = useSelector((state) => state.ThemeChange);
  //console.log(color);
  const [loadings, setLoadings] = useState(true);
  // const simulateLoading = (setLoadings) => {
  //   setLoadings(true);
  //   setTimeout(() => {
  //     setLoadings(false);
  //   }, 2000); // 2 seconds
  // };
  // useEffect(() => {
  //   simulateLoading(setLoadings);
  // }, []);

  let formattedFromDate;
  let formattedToDate;

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`,
    }).then((res) => {
      //console.log(res);
      if (res && res.length > 0) {
        setflowSectionResData(res);
      }
    });
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_PLOT_DETAILS}`,
    }).then((res) => {
      //console.log(res);
      if (res && res.length > 0) {
        setPlotIntervaloptions(res);
      }
    });

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_FUNCTION_DETAILS}`,
    }).then((res) => {
      //console.log(res);
      if (res && res.length > 0) {
        setFunctionOptions(res);
        setFunctions(res)
      }
    });

   

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_PARAMETER_DETAILS}`,
    }).then((res) => {
      //console.log(res);
      if (res && res.length > 0) {
        setParameter(res);
      }
    });
  }, []);

  useEffect(() => {
    if(sectionId==1){
      makeRequest({
       type: APIConstants.GET,
       url: `${APIConstants.GET_ELECTRICAL_CONVERTER_DETAILS}`,
     }).then((res) => {
       //console.log(res);
       if (res && res.length > 0) {
         setgetFlowConverterResData(res);
       }
     });
    }

    if(sectionId==2){
      makeRequest({
        type: APIConstants.POST,
        url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`,
      }).then((res) => {
        //console.log(res);
        if (res && res.length > 0) {
          setflowGroupDetailsResData(res);
        }
      });
    }
  }, [sectionId]);

  useEffect(() => {
    //console.log(converterGroupId);
    //console.log(sectionId);
    if(converterGroupId&&sectionId==1){
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.ELECTRICAL_METERS_DETAILS}?ConverterID=${converterGroupId}`,
      }).then((res) => {
        //console.log(res);
        if (res && res.length > 0) {
               if (defaultLoad) {
            const firstFiveMeters = res
              .slice(0, 5)
              .map((meter) => meter.meterid);

            //console.log(res.map((meter) => meter.meterid));
            //console.log(firstFiveMeters);
            setSelectedMeterIds(firstFiveMeters);
            localStorage.setItem("PlotMeterIds", firstFiveMeters)
            setDefaultLoad(false);
          }
        //    if(defaultLoad){
        //   setSelectedMeterIds(res.map(meter => meter.meterid))
        //   localStorage.setItem("PlotMeterIds", res.map(meter => meter.meterid));
        //   setDefaultLoad(false)
        // }
          setnsGetFlowConverterResData(res);
        }
      });

    }

    if(converterGroupId&& sectionId==2){
      makeRequest({
        type: APIConstants.POST,
        url: `${APIConstants.ELECTRICAL_GROUP_METER_DETAILS}?GroupID=${converterGroupId}&Module=1`,
      }).then((res) => {
        console.log(res);
        if (res && res.length > 0) {
          setgetFlowSteamGroupMeterResData(res);
        }
      });
    }
  }, [converterGroupId]);

function prepareEChartLineData(inputData) {
  if (!Array.isArray(inputData)) return { xAxisData: [], seriesChartData: [] };

  const xAxisSet = new Set();
  const seriesMap = new Map(); // Key: 'METERNAME-Parameter'

  inputData.forEach((item) => {
    const time = new Date(item.CREATEDON).toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
    });
    xAxisSet.add(time);

    Object.keys(item).forEach((key) => {
      if (["CREATEDON", "METERNAME", "METERID", "SITENAME"].includes(key)) return;

      const seriesKey = `${item.METERNAME}-${key}`; // e.g., IVX0105-VR
      if (!seriesMap.has(seriesKey)) {
        seriesMap.set(seriesKey, new Map()); // inner map: time => value
      }
      seriesMap.get(seriesKey).set(time, item[key]);
    });
  });

  const xAxisData = Array.from(xAxisSet).sort(); // time in ascending order
  const seriesChartData = [];

  for (let [name, timeMap] of seriesMap.entries()) {
    const data = xAxisData.map((t) => timeMap.get(t) ?? null); // fill gaps with null
    seriesChartData.push({
      name,
      type: "line",
      smooth: true,
      data,
    });
  }

  return { xAxisData, seriesChartData };
}


  const getResponse = (inputData) => {
    //console.log(inputData);
    //console.log(plotInterval);
    //console.log(functionType)
    setLoadings(true)

    const url =  `${APIConstants.ELECTRICAL_PLOT_INTERVAL_DATA}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIdsorAutoID=${inputData.MeterIds}&FromDate=${inputData.FromDate}&Todate=${inputData.ToDate}&Parameters=${inputData.Parameters}&PlotID=${inputData.plotInterval}&FunctionID=${inputData.functionType}`

    const url1=`https://lucasapi.minnotra.in/api/Electrical/PlotIntervalData?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIdsorAutoID=${inputData.MeterIds}&FromDate=${inputData.FromDate}&ToDate=${inputData.ToDate}&Parameters=${inputData.Parameters}&PlotID=${plotInterval}&FunctionID=${functionType}`

   if(inputData&&inputData.SectionID&&inputData.ConverterorGroupID&&inputData.Parameters&&inputData.MeterIds&&inputData.plotInterval&&inputData.functionType){
     makeRequest({
      type: APIConstants.GET,
      url:url,
    }).then((res) => {
      //console.log(res);
      if (res && res.length > 0) {
        // const data = prepareEChartLineData(res)
        // //console.log(data)
        setReport(res);
        setLoadings(false)
      }else{
        setReport([])
        setLoadings(false)
      }
    });}
  };


// const exportMeterDataToExcel = async (data, minnotra_logo, formattedFromDate, formattedToDate) => {
//   if (!data || data.length === 0) {
//     return;
//   }

//   // Step 1: Extract unique timestamps
//   const uniqueTimestamps = [...new Set(data.map(item => item.CREATEDON))];

//   // Step 2: Extract meter-parameter combinations
//   const meterParams = {};
//   data.forEach(item => {
//     const key = item.METERNAME;
//     if (!meterParams[key]) meterParams[key] = new Set();
//     Object.keys(item).forEach(param => {
//       if (!["METERID", "METERNAME", "SITENAME", "CREATEDON"].includes(param)) {
//         meterParams[key].add(param);
//       }
//     });
//   });

//   // Step 3: Build header & column metadata
//   const header = ["CREATEDON"];
//   const meterColumns = [];

//   Object.entries(meterParams).forEach(([meter, params]) => {
//     [...params].forEach(param => {
//       const colKey = `${meter} - ${param}`;
//       header.push(colKey);
//       meterColumns.push({ meter, param, colKey });
//     });
//   });

//   header.push("Total");

//   // Step 4: Build data rows
//   const rows = [];
//   const columnSums = {};

//   uniqueTimestamps.forEach(timestamp => {
//     const row = { CREATEDON: timestamp.replace("T", " ") };
//     let total = 0;

//     meterColumns.forEach(({ meter, param, colKey }) => {
//       const match = data.find(d => d.METERNAME === meter && d.CREATEDON === timestamp);
//       const value = match ? match[param] : "";
//       row[colKey] = value;

//       if (typeof value === "number") {
//         total += value;
//         columnSums[colKey] = (columnSums[colKey] || 0) + value;
//       }
//     });

//     row.Total = Math.round(total * 1000) / 1000;
//     columnSums["Total"] = (columnSums["Total"] || 0) + row.Total;
//     rows.push(row);
//   });

//   // Step 5: Add grand total row
//   const totalRow = { CREATEDON: "Grand Total" };
//   meterColumns.forEach(({ colKey }) => {
//     totalRow[colKey] = Math.round((columnSums[colKey] || 0) * 1000) / 1000;
//   });
//   totalRow.Total = Math.round((columnSums.Total || 0) * 1000) / 1000;
//   rows.push(totalRow);

//   // Step 6: Create Excel workbook
//   const workbook = new ExcelJS.Workbook();
//   const worksheet = workbook.addWorksheet("Meter Data");

//   // Step 7: Add logo (top-left)
//   if (minnotra_logo) {
//     const buffer = await getImageBufferFromUrl(minnotra_logo);
//     const imageId = workbook.addImage({
//       buffer,
//       extension: "png",
//     });
//     worksheet.mergeCells("A1:B2");
//     worksheet.addImage(imageId, {
//       tl: { col: 0.2, row: 0.2 },
//       ext: { width: 100, height: 38 },
//     });
//   }

//   // Step 8: Add Report Title
//   worksheet.mergeCells("C1:H2"); // Merge across some columns
//   const titleCell = worksheet.getCell("C1");
//   titleCell.value = "Plot Report";
//   titleCell.font = { bold: true, size: 16, color: { argb: "FF000000" } };
//   titleCell.alignment = { vertical: "middle", horizontal: "center" };

//   // Step 9: Add From & To Date below title
//   worksheet.mergeCells("A3:C3");
//   worksheet.getCell("A3").value = `From: ${formattedFromDate}`;
//   worksheet.getCell("A3").font = { bold: true };
//   worksheet.getCell("A3").alignment = { horizontal: "left" };

//   worksheet.mergeCells("D3:F3");
//   worksheet.getCell("D3").value = `To: ${formattedToDate}`;
//   worksheet.getCell("D3").font = { bold: true };
//   worksheet.getCell("D3").alignment = { horizontal: "left" };

//   // Step 10: Add headers with styling (Row 5)
//   const headerRowIndex = 5;
//   worksheet.getRow(headerRowIndex).values = header;

//   const headerRow = worksheet.getRow(headerRowIndex);
//   headerRow.eachCell((cell) => {
//     cell.fill = {
//       type: "pattern",
//       pattern: "solid",
//       fgColor: { argb: "FF00B050" }, // Green
//     };
//     cell.font = {
//       bold: true,
//       color: { argb: "FFFFFFFF" }, // White
//     };
//     cell.alignment = { vertical: "middle", horizontal: "center" };
//     cell.border = {
//       top: { style: "thin" },
//       left: { style: "thin" },
//       bottom: { style: "thin" },
//       right: { style: "thin" },
//     };
//   });

//   // Step 11: Add data starting from row 6
//   rows.forEach((rowData) => {
//     const values = header.map(h => rowData[h] ?? "");
//     const row = worksheet.addRow(values);

//     row.eachCell((cell) => {
//       cell.border = {
//         top: { style: "thin" },
//         left: { style: "thin" },
//         bottom: { style: "thin" },
//         right: { style: "thin" },
//       };
//     });
//   });

//   // Step 12: Auto-fit column widths
//   header.forEach((h, i) => {
//     const col = worksheet.getColumn(i + 1); // 1-based
//     let maxLength = h.length; // start with header length

//     col.eachCell({ includeEmpty: true }, (cell) => {
//       const cellValue = cell.value ? cell.value.toString() : "";
//       maxLength = Math.max(maxLength, cellValue.length);
//     });

//     col.width = Math.min(Math.max(maxLength + 2, 12), 50);
//   });

//   // Step 13: Export the file
//   const buffer = await workbook.xlsx.writeBuffer();
//   const blob = new Blob([buffer], { type: "application/octet-stream" });
//   saveAs(blob, "MeterDataExport.xlsx");
// };

const exportMeterDataToExcel = async (data, minnotra_logo, formattedFromDate, formattedToDate) => {
  if (!data || data.length === 0) {
    return;
  }

  // Step 1: Extract unique timestamps
  const uniqueTimestamps = [...new Set(data.map(item => item.CREATEDON))];

  // Step 2: Extract meter-parameter combinations
  const meterParams = {};
  data.forEach(item => {
    const key = item.METERNAME;
    if (!meterParams[key]) meterParams[key] = new Set();
    Object.keys(item).forEach(param => {
      if (!["METERID", "METERNAME", "SITENAME", "CREATEDON"].includes(param)) {
        meterParams[key].add(param);
      }
    });
  });

  // Step 3: Build header & column metadata
  const header = ["CREATEDON"];
  const meterColumns = [];

  Object.entries(meterParams).forEach(([meter, params]) => {
    [...params].forEach(param => {
      const colKey = `${meter} - ${param}`;
      header.push(colKey);
      meterColumns.push({ meter, param, colKey });
    });
  });

  // header.push("Total");

  // Step 4: Build data rows
  const rows = [];
  const columnSums = {};

  uniqueTimestamps.forEach(timestamp => {
    const row = { CREATEDON: timestamp.replace("T", " ") };
    let total = 0;

    meterColumns.forEach(({ meter, param, colKey }) => {
      const match = data.find(d => d.METERNAME === meter && d.CREATEDON === timestamp);
      const value = match ? match[param] : "";
      row[colKey] = value;

      if (typeof value === "number") {
        total += value;
        columnSums[colKey] = (columnSums[colKey] || 0) + value;
      }
    });

    row.Total = Math.round(total * 1000) / 1000;
    columnSums["Total"] = (columnSums["Total"] || 0) + row.Total;
    rows.push(row);
  });

  // Step 5: Add grand total row
  const totalRow = { CREATEDON: "Grand Total" };
  meterColumns.forEach(({ colKey }) => {
    totalRow[colKey] = Math.round((columnSums[colKey] || 0) * 1000) / 1000;
  });
  totalRow.Total = Math.round((columnSums.Total || 0) * 1000) / 1000;
  rows.push(totalRow);

  // Step 6: Create Excel workbook
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Meter Data");

  // Step 7: Add logo (top-left)
  if (minnotra_logo) {
    const buffer = await getImageBufferFromUrl(minnotra_logo);
    const imageId = workbook.addImage({
      buffer,
      extension: "png",
    });
    worksheet.mergeCells("A1:B2");
    worksheet.addImage(imageId, {
      tl: { col: 0.2, row: 0.2 },
      ext: { width: 100, height: 38 },
    });
  }

  // Step 8: Add Report Title (Row 3-4 so it's below logo)
  worksheet.mergeCells("C3:H4");
  const titleCell = worksheet.getCell("C3");
  titleCell.value = "Plot Report";
  titleCell.font = { bold: true, size: 16, color: { argb: "FF000000" } };
  titleCell.alignment = { vertical: "middle", horizontal: "center" };

  // Step 9: Add From & To Date (Row 5)
  worksheet.mergeCells("A5:C5");
  worksheet.getCell("A5").value = `From: ${formattedFromDate}`;
  worksheet.getCell("A5").font = { bold: true };
  worksheet.getCell("A5").alignment = { horizontal: "left" };

  worksheet.mergeCells("D5:F5");
  worksheet.getCell("D5").value = `To: ${formattedToDate}`;
  worksheet.getCell("D5").font = { bold: true };
  worksheet.getCell("D5").alignment = { horizontal: "left" };

 // Step 10: Add headers at row 7
const headerRow = worksheet.addRow(header);
headerRow.eachCell((cell) => {
  cell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FF00B050" }, // Dark green
  };
  cell.font = {
    bold: true,
    color: { argb: "FFFFFFFF" }, // White text
  };
  cell.alignment = { vertical: "middle", horizontal: "center" };
  cell.border = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  };
});

// ✅ Fix column widths same for all rows
header.forEach((_, i) => {
  worksheet.getColumn(i + 1).width = 18; // set a fixed width (adjust as needed)
});

// Step 11: Add data starting from row 8
rows.forEach((rowData) => {
  const values = header.map(h => rowData[h] ?? "");
  const row = worksheet.addRow(values);

  // Apply border
  row.eachCell((cell) => {
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // ✅ Style "Grand Total" row same as old Total row
  if (rowData.CREATEDON === "Grand Total") {
    row.eachCell((cell) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFD9EAD3" }, // light green shade
      };
      cell.font = {
        bold: true,
        color: { argb: "FF000000" }, // black text
      };
    });
  }
});


  // Step 12: Auto-fit column widths
  header.forEach((h, i) => {
    const col = worksheet.getColumn(i + 1); // 1-based
    let maxLength = h.length;

    col.eachCell({ includeEmpty: true }, (cell) => {
      const cellValue = cell.value ? cell.value.toString() : "";
      maxLength = Math.max(maxLength, cellValue.length);
    });

    col.width = Math.min(Math.max(maxLength + 2, 12), 50);
  });

  // Step 13: Export the file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/octet-stream" });
  saveAs(blob, "PlotReport.xlsx");
};

const getImageBufferFromUrl = async (url) => {
  const response = await fetch(url);
  return await response.arrayBuffer();
};

const exportMeterDataToExcelfine = async (data, minnotra_logo,formattedFromDate,formattedToDate) => {
  if (!data || data.length === 0) {
    return;
  }

  // Step 1: Extract unique timestamps
  const uniqueTimestamps = [...new Set(data.map(item => item.CREATEDON))];

  // Step 2: Extract meter-parameter combinations
  const meterParams = {};
  data.forEach(item => {
    const key = item.METERNAME;
    if (!meterParams[key]) meterParams[key] = new Set();
    Object.keys(item).forEach(param => {
      if (!["METERID", "METERNAME", "SITENAME", "CREATEDON"].includes(param)) {
        meterParams[key].add(param);
      }
    });
  });

  // Step 3: Build header & column metadata
  const header = ["CREATEDON"];
  const meterColumns = [];

  Object.entries(meterParams).forEach(([meter, params]) => {
    [...params].forEach(param => {
      const colKey = `${meter} - ${param}`;
      header.push(colKey);
      meterColumns.push({ meter, param, colKey });
    });
  });

  header.push("Total");

  // Step 4: Build data rows
  const rows = [];
  const columnSums = {};

  uniqueTimestamps.forEach(timestamp => {
    const row = { CREATEDON: timestamp.replace("T", " ") };
    let total = 0;

    meterColumns.forEach(({ meter, param, colKey }) => {
      const match = data.find(d => d.METERNAME === meter && d.CREATEDON === timestamp);
      const value = match ? match[param] : "";
      row[colKey] = value;

      if (typeof value === "number") {
        total += value;
        columnSums[colKey] = (columnSums[colKey] || 0) + value;
      }
    });

    row.Total = Math.round(total * 1000) / 1000;
    columnSums["Total"] = (columnSums["Total"] || 0) + row.Total;
    rows.push(row);
  });

  // Step 5: Add grand total row
  const totalRow = { CREATEDON: "Grand Total" };
  meterColumns.forEach(({ colKey }) => {
    totalRow[colKey] = Math.round((columnSums[colKey] || 0) * 1000) / 1000;
  });
  totalRow.Total = Math.round((columnSums.Total || 0) * 1000) / 1000;
  rows.push(totalRow);

  // Step 6: Create Excel workbook
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Meter Data");

  // Step 7: Add logo
  if (minnotra_logo) {
    const buffer = await getImageBufferFromUrl(minnotra_logo);
    const imageId = workbook.addImage({
      buffer,
      extension: "png",
    });
    worksheet.mergeCells("A1:B2");
    worksheet.addImage(imageId, {
      tl: { col: 0.2, row: 0.2 },
      ext: { width: 100, height: 38 },
    });
  }

  // Step 8: Add headers with styling (Row 4)
  const headerRowIndex = 4;
  worksheet.getRow(headerRowIndex).values = header;

  const headerRow = worksheet.getRow(headerRowIndex);
  headerRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF00B050" }, // Green
    };
    cell.font = {
      bold: true,
      color: { argb: "FFFFFFFF" }, // White
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });


 // Step 9: Add data starting from row 5
rows.forEach((rowData) => {
  const values = header.map(h => rowData[h] ?? "");
  const row = worksheet.addRow(values);

  row.eachCell((cell) => {
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });
});

// ✅ Step 9b: Auto-fit column widths (header + data)
header.forEach((h, i) => {
  const col = worksheet.getColumn(i + 1); // 1-based
  let maxLength = h.length; // start with header length

  col.eachCell({ includeEmpty: true }, (cell) => {
    const cellValue = cell.value ? cell.value.toString() : "";
    maxLength = Math.max(maxLength, cellValue.length);
  });

  col.width = Math.min(Math.max(maxLength + 2, 12), 50); 
  // min 12, max 50 to prevent super wide columns
});


  // Step 10: Export the file
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: "application/octet-stream" });
  saveAs(blob, "MeterDataExport.xlsx");
};



  const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList =
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList =
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList =
    (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
  const getFlowSteamGroupMeterList =
    (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);

  const handleChangeSection = (changedValues) => {
    setSectionId(changedValues);
    setConverterGroupId()
    setSelectedMeterIds();
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    setConverterGroupId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    if (selectedValues) {
      setMeterError("");
    }
  };

    useEffect(() => {
      //console.log(selectedValues)
    if(selectedValues.length==0){
     setFunctionOptions(functions)
    }

  }, [selectedValues]);

  const handleTreeChange = (values) => {
    //console.log(values)
    setSelectedValues(values);
    //console.log(values)
  //   [
  //   'KWHTotal', 'kWhImport', 'KWHEXPORT', 'kVAh', 'kVArhTotal', 'kVArhinductive', 'KVARHCAPACITIVE'
  // ]
    if (values.includes('KWHTotal')||values.includes('kWhImport')||values.includes('KWHEXPORT')||values.includes('kVAh')||values.includes('kVArhTotal')||values.includes('kVArhinductive')||values.includes('KVARHCAPACITIVE')) {
    const excludeNames = ['Addition', 'Avg','Min','Max'];
    const newFunctionOptions = functionOptions.filter(
      f => !excludeNames.includes(f.functionName)
    );
      //console.log(newFunctionOptions)
      setFunctionOptions(newFunctionOptions)
    }else{
  const newFunctionOptions= functionOptions.filter(f => f.functionName !== 'Cumulative');
  //console.log(newFunctionOptions)
  setFunctionOptions(newFunctionOptions)

}

//console.log(functionOptions);
    if (values) {
      setParaError("");
    }
  };

  const onChangeFromDate = (dateString) => {
    setFromDateString(dateString);
    setFromDateObj(dateString);
    if (dateString) {
      setFromDateError("");
    }
  };

  const onChangeToDate = (dateString) => {
    //console.log(dateString)
    setToDateString(dateString);
    setToDateObj(dateString);
    if (dateString) {
      setToDateError("");
    }
  };

  const setChartInputData = () => {
    // const [date, time] =  fromDateString?.split("T")
    // const [toDateSplit, toTimeSplit] =toDateString?.split("T")
    const fromDateTimeStamp = fromDateString;

    const fromDate = new Date(fromDateString || new Date());
    const toDate = new Date(toDateString || new Date());

    const fromHours = fromDate.getUTCHours();
    const fromMinutes = fromDate.getUTCMinutes();
    const fromSeconds = fromDate.getUTCSeconds();

    const toHours = toDate.getUTCHours();
    const toMinutes = toDate.getUTCMinutes();
    const toSeconds = toDate.getUTCSeconds();

    // const [fromHours, fromMinutes, fromSeconds] = time?.split(":").map(Number);
    // const [toHours, toMinutes, toseconds] = toTimeSplit?.split(":").map(Number);

    // Set the UTC hours, minutes, and seconds
    fromDate.setUTCHours(fromHours);
    fromDate.setUTCMinutes(fromMinutes);
    fromDate.setUTCSeconds(fromSeconds);

    toDate.setUTCHours(toHours);
    toDate.setUTCMinutes(toMinutes);
    toDate.setUTCSeconds(toSeconds);

    formattedFromDate = generatedISOFormatDateString(fromDate);
    formattedToDate = generatedISOFormatDateString(toDate);
    //console.log(fromDateString);
    //console.log(toDateString);
    console.log(formatDateTime(formattedFromDate));
    console.log(formattedToDate);

    const ids = selectedMeterIds?.map((id) => id).join(",");
    const para = selectedValues?.map((id) => id).join(",");
    //console.log(para) 
    //console.log(ids) 
    setExcelFromDate(formatDateTime(formattedFromDate))
    setExcelToDate(formatDateTime(formattedToDate))

    const inputData = {
      SectionID: Number(sectionId) || 0,
      ConverterorGroupID: Number(converterGroupId) || 2,
      MeterIds: ids || 0,
      Parameters: para || 0,
      plotInterval:plotInterval,
      functionType:functionType,
      FromDate: formattedFromDate || "2023-09-21 07:15:00.000",
      ToDate: formattedToDate || "2023-09-25 07:15:00.000",
    };
    // const queryString = objectToQueryString(inputData);
    // setChartInput(queryString);
    getResponse(inputData);
  };

  useEffect(() => {
    setChartInputData();
  }, [defaultLoad]);
  useEffect(() => {
    setChartInputData();
  }, []);

  // const plotIntervalOptions = [
  //   { label: "1 min", value: 1 },
  //   { label: "5 min", value: 2 },
  //   { label: "10 min", value: 3 },
  //   { label: "15 min", value: 4 },
  //   { label: "30 min", value: 5 },
  //   { label: "60 min", value: 6 },
  //   { label: "Shift", value: 7 },
  //   { label: "Daily", value: 8 },
  //   { label: "Monthly", value: 9 },
  // ];

  // const functionOptions = [
  //   { label: "Raw Data", value: 1 },
  //   { label: "Avg", value: 2 },
  //   { label: "Min", value: 3 },
  //   { label: "Max", value: 4 },
  // ];

  const handlePlotIntervalChange = (value) => {
    //console.log(value)
    setPlotInterval(value);
    if (value) {
      setPlotIntervalError("");
    } else {
      setPlotIntervalError("Please select a plot interval");
    }
  };
  const handleFunctionTypeChange = (value) => {
    //console.log(value)
    setFunctionType(value);
    if (value) {
      setFunctionTypeError("");
    } else {
      setFunctionTypeError("Please select a function type");
    }
  };

  useEffect(() => {
    setChartSkip(false);
  }, [chartInput, steamRawData, selectedValues]);

  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };
  const validateDateRange = (from, to, plotInterval) => {
    const diffMinutes = dayjs(to).diff(dayjs(from), "minute");
    const diffHours = dayjs(to).diff(dayjs(from), "hour");
    const diffDays = dayjs(to).diff(dayjs(from), "day");
    const interval = Number(plotInterval);

    let errors = [];

    switch (interval) {
      case 1: // 1 min
      case 2: // 5 min
        if (diffMinutes < 10) errors.push("Minimum 10 minutes required");
        else if (diffMinutes % (interval === 1 ? 1 : 5) !== 0) {
          errors.push(
            `Time range must be a multiple of ${interval === 1 ? 1 : 5} minutes`
          );
        }
        break;

      case 3: // 10 min
        if (diffMinutes < 30) errors.push("Minimum 30 minutes required");
        else if (diffMinutes % 10 !== 0) {
          errors.push("Time range must be a multiple of 10 minutes");
        }
        break;

      case 4: // 15 min
        if (diffMinutes < 30) errors.push("Minimum 30 minutes required");
        else if (diffMinutes % 15 !== 0) {
          errors.push("Time range must be a multiple of 15 minutes");
        }
        break;

      case 5: // 30 min
        if (diffMinutes < 30) errors.push("Minimum 30 minutes required");
        else if (diffMinutes % 30 !== 0) {
          errors.push("Time range must be a multiple of 30 minutes");
        }
        break;

      case 6: // 60 min
        if (diffMinutes < 120) errors.push("Minimum 2 hours required");
        else if (diffMinutes % 60 !== 0) {
          errors.push("Time range must be a multiple of 60 minutes");
        }
        break;

      case 7: // Shift (8-hour multiple)
        if (diffHours < 24)
          errors.push("Minimum 24 hours required for Shift interval");
        else if (diffHours % 8 !== 0) {
          errors.push(
            "Time range must be a multiple of 8 hours for Shift interval"
          );
        }
        break;

      case 8: // Daily (24-hour multiple)
        if (diffDays < 7)
          errors.push("Minimum 7 days required for Daily interval");
        else if (diffHours % 24 !== 0) {
          errors.push(
            "Time range must be a multiple of 24 hours for Daily interval"
          );
        }
        break;

      case 9: // Monthly
        if (diffDays < 90)
          errors.push("Minimum 90 days required for Monthly interval");
        break;

      default:
        errors.push("Invalid interval selected");
    }

    return errors.length ? errors.join(". ") + "." : null;
  };
  const handleSubmit = () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds?.length, "Meter");
    const paraError = validateInput(selectedValues?.length, "Parameter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateInput(toDateString, "To Date");
    const plotIntervalError = validateInput(plotInterval, "Plot Interval");
    const functionTypeError = validateInput(functionType, "Function Type");
    const dateError = validateDateRange(fromDateObj, toDateObj, plotInterval);

    setSectionError(sectionError);
    setConverterError(converterError);
    setMeterError(meterError);
    setParaError(paraError);
    setFromDateError(fromDateError);
    setPlotIntervalError(plotIntervalError);
    setFunctionTypeError(functionTypeError);
    setToDateError(toDateError);
      if(fromDateError||toDateError){
      setDatesError('Please select a date range')
    }
    setDatesError(dateError)
    if (
      !sectionError &&
      !converterError &&
      !meterError &&
      !paraError &&
      !fromDateError &&
      !toDateError &&
      !dateError&&
      !datesError&&
      !functionTypeError&&
      !plotIntervalError

    ) {
      onClose();
      setChartInputData();
    }
  };

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--date-ok-btn",
      color.themeConfig.colorPrimary
    );
    document.documentElement.style.setProperty("--date-now-btn", "#fff");
  }, [color]);

  const today = dayjs();
  const startOfWeek = dayjs().weekday(0); // Sunday
  const endOfWeek = dayjs().weekday(6); // Saturday
  const startOfLastWeek = dayjs().subtract(1, "week").weekday(0);
  const endOfLastWeek = dayjs().subtract(1, "week").weekday(6);
  const startOfMonth = dayjs().startOf("month");
  const endOfMonth = dayjs().endOf("month");
  const startOfLastMonth = dayjs().subtract(1, "month").startOf("month");
  const endOfLastMonth = dayjs().subtract(1, "month").endOf("month");

  const rangePresets = [
    // { label: "Today", value: [today.startOf("day"), today.endOf("day")] },
    { label: "Yesterday", value: [today.subtract(1, "day").startOf("day"), today.startOf("day")] },
    { label: "This Week", value: [startOfWeek, endOfWeek] },
    { label: "Last Week", value: [startOfLastWeek, endOfLastWeek] },
    { label: "This Month", value: [startOfMonth, endOfMonth] },
    { label: "Last Month", value: [startOfLastMonth, endOfLastMonth] },
    { label: "Last 7 Days", value: [dayjs().subtract(7, "day"), today] },
    { label: "Last 14 Days", value: [dayjs().subtract(14, "day"), today] },
    { label: "Last 30 Days", value: [dayjs().subtract(30, "day"), today] },
    { label: "Last 90 Days", value: [dayjs().subtract(90, "day"), today] },
  ];

    const handleDateChange = (value) => {
    // if (!value) return;
    // const diff = value[1]?.diff(value[0], "day");

    // if (diff > MAX_DAYS) {
    //   alert("Date range cannot exceed 90 days");
    //   return;
    // }

    if (value) {
      // const fromDate = value[0];
      // const toDate = value[1];
      const fromDate = value[0]?.format("YYYY-MM-DD HH:mm:ss");
      const toDate = value[1]?.format("YYYY-MM-DD HH:mm:ss");
      if(!fromDate&& !toDate){
        setDatesError('Please select a date range');
      }else{
        setDatesError(null)
      }

      //console.log([fromDate, toDate]);
      setValue([value[0], value[1]]);
      onChangeFromDate(fromDate);
      onChangeToDate(toDate);
    } else {
      setDatesError('Please select a date range');
    }
  };
    //console.log(activeTab);
    //console.log(functionOptions)
    //console.log(plotIntervalOptions)
  return (
    <div
      className={` rounded-md p-4 py-0 w-auto dark ${isdarkMode ? "darkmode" : "whitemode"} `}
    >
      <div className="flex justify-between items-center px-2 pb-0">
        <div className="text-3xl">
          <h4
            className={`text-center  mb-5 dark ${isdarkMode ? "darkfont" : "whitemode"}`}
          >
            Plot Report
          </h4>
        </div>
      </div>
      <div className=" gap-2 flex justify-between mr-2">
        <Space style={{ marginBottom: 16 }}>
          <Radio.Group
            value={activeTab}
            onChange={(e) => {
              setActiveTab(e.target.value);
            }}
            style={{ marginBottom: 16 }}
          >
            <Radio.Button value="1">Line Chart</Radio.Button>
            <Radio.Button value="2">Stacked Column Chart</Radio.Button>
            <Radio.Button value="3">Grouped Column Chart</Radio.Button>
          </Radio.Group>
        </Space>
        <div className=" flex gap-3">
          <Button
            role="primary"
            size="large"
            className="flex justify-center items-center secondary-btn"
            style={{
              "--secondary-color": color.themeConfig.secondaryColor,
              "--primary-color": color.themeConfig.colorPrimary,
            }}
            onClick={() => setOpen(!open)}
          >
            <FilterOutlined /> Filter
          </Button>
          <Button
            role="primary"
            size="large"
            className="flex justify-center items-center secondary-btn"
            style={{
              "--secondary-color": color.themeConfig.secondaryColor,
              "--primary-color": color.themeConfig.colorPrimary,
            }}
            disabled={report&&report.length==0}
            onClick={() => {
              excelImage?exportMeterDataToExcel(report,excelImage,excelFromDate,excelToDate):
              exportMeterDataToExcel(report,minnotra_logo,excelFromDate,excelToDate)
            }}
          >
            <FilterOutlined /> Export To Excel
          </Button>

        </div>
        {/* <ExportToExcel
            disable={report && report?.length === 0}
            size="large"
              report={report}
              meters={selectedMeters()}
              parameter={selectedValues?.length === 2}
            /> */}
      </div>
      {loadings&&<>
      <Skeleton/>
      </>}
      {!loadings && !loading && report.length > 0 && (
        <div className={`m-2 my-0`}>
          {activeTab == "1" && (
            <>
            <LineChart style={{ height: 700 }}report={report} metric="kvart" />
            </>
          )}
          {activeTab == "2" && (
 <>
            <StackedColumnChart report={report} style={{ height: 700 }} />
            </>          )}
          {activeTab == "3" && (
 <>
            <GroupedColumnChart report={report} style={{ height: 700 }} />
            </>          )}

          {/* <TableComponent 
            report={report}
            meters={selectedMeters()} 
            parameter={selectedValues.length === 2}
          /> */}
        </div>
      ) 
      
    } 
    {!loadings && !loading && report.length === 0 &&
      (
        <>
          {/* <Skeleton active paragraph={{ rows: 6 }} /> */}
          <div className={`${isdarkMode ? "" : ""}`}>
            <Empty open={open} setOpen={setOpen} isdarkMode={isdarkMode} />
          </div>
        </>
      )
      }

      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
             selectedValues={sectionId}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "siteID" : "groupID"}
            nameKey={sectionId === 1 ? "siteName" : "department"}
            selectedValues={converterGroupId}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small> 
          <SteamTreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId === 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
            }
            idKey={sectionId === 1 ? "meterid" : "meterid"}
            valueKey={sectionId === 1 ? "meterid" : "meterid"}
            nameKey={sectionId === 1 ? "metername" : "metername"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>
          <TreeSelectCustom
            label="Parameters:"
            data={parameter}
            idKey="parameterid"
            nameKey="parametername"
            valueKey="parameterid"
            selectedValues={selectedValues}
            setSelectedValues={setSelectedValues}
            onSelect={handleTreeChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {paraError}
          </small>
          <CustomSelect
            label="Plot Interval:"
            options={plotIntervalOptions}
            onSelect={handlePlotIntervalChange}
            valueKey="plotID"
            nameKey="plotName"
            selectedValues={plotInterval}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {plotIntervalError}
          </small>

          <CustomSelect
            label="Function:"
            options={functionOptions}
            onSelect={handleFunctionTypeChange}
            valueKey="functionID"
            nameKey="functionName"
            selectedValues={functionType}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {functionTypeError}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32  text-left"> Date:</label>
            <RangePicker
              value={value}
              onChange={handleDateChange}
              popupClassName="custom-picker"
              presets={rangePresets}
              format="YYYY-MM-DD HH:mm:ss"
              showTime={{ format: "HH:mm:ss" }}
              className={`w-80 ml-0 shadow-lg rounded-3xl  ${
                isdarkMode
                  ? "customRangePicker-dark  text-white"
                  : "customRangePicker-light text-black"
              }`}
              panelRender={(originalPanel) => {
                if (!showCalendar) {
                  return (
                    <div
                      className={`${
                        isdarkMode ? "bg-[#1a1a1a]" : "bg-white"
                      } flex flex-col gap-1 p-2 w-44 rounded`}
                    >
                      {rangePresets.map((preset) => (
                        <div
                          key={preset.label}
                          onClick={() => handleDateChange(preset.value)}
                          className={`cursor-pointer px-2 py-1 rounded ${
                            isdarkMode
                              ? "text-white hover:bg-gray-700"
                              : "text-black hover:bg-gray-200"
                          }`}
                        >
                          {preset.label}
                        </div>
                      ))}
                      <button
                        onClick={() => setShowCalendar(true)}
                        className={`mt-2 px-2 py-1 rounded  border text-center ${
                          isdarkMode
                            ? "bg-[#1a1a1a] border-white text-white hover:bg-gray-700"
                            : "bg-white border-black text-black hover:bg-gray-200"
                        }`}
                      >
                        Custom Dates
                      </button>
                    </div>
                  );
                }
                return originalPanel;
              }}
              onOpenChange={(open) => {
                if (!open) setShowCalendar(false);
              }}
            />
          </div>
          <small className="text-red-500 font-bold ml-[150px]">
            {fromDateError|| datesError}
          </small>
        </div>
        <div className="flex justify-center mt-4">
          <Button
            type={isdarkMode ? "" : "primary"}
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button>
        </div>
      </CustomDrawer>
      <style>
        {`
          .custom-picker .ant-picker-ok .ant-btn{
            background-color: var(--date-ok-btn) !important;
            border-color: var(--date-ok-btn) !important;
            color: white !important;
          }
          .custom-picker .ant-picker-ok .ant-btn:hover {
            background-color: var(--date-ok-btn) !important;
            border-color: #d9363e !important;
          }
          .custom-picker .ant-picker-now .ant-picker-now-btn {
            color: var(--date-ok-btn) !important;
          }
          .custom-picker .anticon-swap-right, .anticon-calendar{
            // background-color: red !important;
            color: var(--date-ok-btn) !important;
          }
        `}
      </style>
    </div>
  );
};

export default PlotInterval;
